export function formatCurrency(amount,isSpan = false) {
    const value = parseFloat(amount || 0);
    const isPositive = value >= 0;
    const formatted = isPositive
      ? `$${value.toFixed(2)}`
      : `-$${Math.abs(value).toFixed(2)}`;
  
    return (
        isSpan ? (
            <span className={isPositive ? 'text-green-600' : 'text-red-600'}>
                {formatted}
            </span>
        ) : (
            formatted
        )
    );
  }